import useSWR from 'swr';
import fetcher from 'lib/fetcher';
import { APIUserType } from 'api/types';

export type APIUser = {
  id: number;
  fullname: { firstName: string; lastName?: string; patronymic?: string };
  phone: string;
  type: APIUserType;
};

const useUserList = () => {
  const { data, error, isLoading, mutate } = useSWR<APIUser[]>('/users/users', fetcher.swr, {
    errorRetryCount: 0,
    revalidateOnFocus: false,
  });
  return { users: data ?? [], error, isLoading, mutate };
};

export default useUserList;
